// brand.ts — single source of truth for the brand-color fallback.
//
// schema.metadata.brand_color carries the operator's picked color (threaded
// from the Studio color picker through the claim bundle). When it is genuinely
// missing, components fell back to three different literals (#6366F1, #4ade80,
// #0f172a), so a color-less Agentic Operating System rendered inconsistently across screens. They now
// all default to this one constant.
export const DEFAULT_BRAND_COLOR = "#6366F1";

// Force interactive elements (primary buttons / CTAs) to a visible color. The
// picked brand color is used as-is unless it is too dark / near-black to read
// against a dark surface (where buttons blend) — then fall back to a
// guaranteed-visible accent. Buttons use white text, so the fallback must pair
// with white text.
const INTERACTIVE_FALLBACK = "#DC2626"; // red-600 — visible on light AND dark surfaces

export function interactiveAccent(color?: string | null): string {
  const m = /^#?([0-9a-fA-F]{6})$/.exec(String(color || "").trim());
  if (!m) return DEFAULT_BRAND_COLOR; // unknown/short → the indigo default (already visible)
  const n = parseInt(m[1], 16);
  const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
  const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255; // sRGB approximation
  return luminance < 0.22 ? INTERACTIVE_FALLBACK : `#${m[1]}`;
}
